import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SiteLayout from "./components/SiteLayout";
import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import ServicesPage from "./pages/Services";
import IndustriesPage from "./pages/Industries";
import WhyChooseUsPage from "./pages/WhyChooseUs";
import TestimonialsPage from "./pages/Testimonials";
import FAQsPage from "./pages/FAQs";
import ContactPage from "./pages/Contact";
import RequestTitleSearchPage from "./pages/RequestTitleSearch";
import TermsPage from "./pages/Terms";
import RefundPolicyPage from "./pages/RefundPolicy";
import JoinExpertsPage from "./pages/JoinExperts";
import DueDiligenceTrackerPage from "./pages/DueDiligenceTracker";
import RatingPage from "./pages/RatingPage";
import PublicReportPage from "./pages/PublicReport";
import PaymentSuccessPage from "./pages/PaymentSuccess";
import PricingPage from "./pages/Pricing";
import SampleReportPage from "./pages/SampleReport";
import AskTerraaPage from "./pages/AskTerraa";
import AdminLoginPage from "./pages/AdminLogin";
import AdminDashboardPage from "./pages/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/request-title-search" element={<RequestTitleSearchPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/join-experts" element={<JoinExpertsPage />} />
          <Route path="/due-diligence-tracker" element={<DueDiligenceTrackerPage />} />
          <Route path="/rating" element={<RatingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/sample-report" element={<SampleReportPage />} />
          <Route path="/ask-terraa" element={<AskTerraaPage />} />
          <Route path="/report/:id" element={<PublicReportPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
        </Route>
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
